"use client"

import type React from "react"
import "./globals.css"
import { Providers } from "@/app/components/providers"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

export default function ClientLayout({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const pathname = usePathname()

  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo(0, 0)
    }
  }, [pathname])

  return (
    <Providers>
      <div className="flex flex-col min-h-screen">{children}</div>
    </Providers>
  )
}
